module.exports = __webpack_public_path__ + "img/processing-08.627a43ee.gif";